import { createNativeStackNavigator } from '@react-navigation/native-stack';
import ProfileFormScreen from 'screens/Profiles/FormScreen';
import ProfileSelectionScreen from 'screens/Profiles/SelectionScreen';

import ProfileLayout from 'components/Profile/ProfileLayout';

export type ProfileStackParamList = {
  ProfileSelection: undefined;
  ProfileCreate: undefined;
  ProfileEdit: { profileId: string };
};

const Stack = createNativeStackNavigator<ProfileStackParamList>();

export const ProfileStack = () => {
  return (
    <ProfileLayout>
      <Stack.Navigator screenOptions={{ headerShown: false, title: 'Bandplay' }}>
        <Stack.Screen name="ProfileSelection" component={ProfileSelectionScreen} />
        <Stack.Screen name="ProfileCreate" component={ProfileFormScreen} />
        <Stack.Screen name="ProfileEdit" component={ProfileFormScreen} />
      </Stack.Navigator>
    </ProfileLayout>
  );
};
